/* Ottiene il totale delle firme applicate */
export const getSignaturesSum = (data: number[]) =>
  data.reduce((acc, a) => acc + a, 0);
